export const initialState = {
  enabled: false,
  selected: false,
  selectionLocked: false,
  monthName: null,
  product: null,
  isFetching: false,
}

export const setData = (state, payload) => ({
  ...payload, isFetching: false,
})

export const setFetching = (state, payload) => ({
  ...state, isFetching: payload,
})

export const setSelected = (state, payload) => ({
  ...state, selected: payload,
})

export const reset = () => initialState
